import { useSolanaQuickPlay } from "../hooks/useSolanaQuickPlay";

/**
 * Headless, App-scoped mount of the Solana quick-play hook. Renders nothing —
 * it exists so the auto-sweep (delegated wallet SOL → Vault) runs for the WHOLE
 * session, not just while the Wallet Panel happens to be open. Without this the
 * Vault is never funded from normal use / Settings, and match locks fail with
 * InsufficientFunds even though the user has wallet SOL.
 *
 * Mount only when SOLANA_NETWORK && logged in (see App.tsx). Exactly ONE
 * instance should be live at a time — the hook's sweepingRef only serialises
 * within a single instance.
 */
export default function SolanaQuickPlayDaemon({ walletAddress }: { walletAddress: string | null }) {
  useSolanaQuickPlay(walletAddress);
  return null;
}
